import * as R from 'ramda';
import { createSelector } from 'reselect';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
//////////////////////////////////////////////////

const store = ({ serviceVendorInvoice }) => serviceVendorInvoice;

const makeSelectReportStatus = () => createSelector(
  store,
  ({ reportPending }) => reportPending,
);

const makeSelectAvailableReports = () => createSelector(
  store,
  ({ availableReports }) => availableReports,
);

const makeSelectUsedReport = () => createSelector(
  store,
  ({ usedReport }) => usedReport,
);

const makeSelectTableTitleFilters = () => createSelector(
  store,
  ({ tableTitleFilters }) => tableTitleFilters,
);

const makeSelectTitleSortValues = () => createSelector(
  store,
  ({ titleSortValues }) => titleSortValues,
);

const makeSelectItemList = () => createSelector(
  store,
  ({ itemList }) => R.sortBy(R.prop('index'), R.values(itemList)),
);

const makeSelectPagination = () => createSelector(
  store,
  ({ pagination }) => pagination,
);

const makeSelectTotalCount = () => createSelector(
  store,
  ({ totalCount }) => totalCount,
);

const makeSelectListLoading = () => createSelector(
  store,
  ({ loading }) => loading,
);

const makeSelectConfigs = () => createSelector(
  store,
  ({ configs }) => ({
    carrierInvoicesStatuses: G.createOptionsFromDropdownConfigWithGuidOrParentGuid(
      configs,
      GC.INVOICE_CI_STATUS,
      true,
    ),
  }),
);

const makeSelectReconciliationConfigs = () => createSelector(
  store,
  ({ currentBranchConfigs }) => {
    const rejectStatusReason = G.createOptionsFromDropdownConfigWithGuidOrParentGuid(
      currentBranchConfigs,
      GC.INVOICE_CARRIER_REJECT_REASON,
    );
    const approveStatusReason = G.createOptionsFromDropdownConfigWithGuidOrParentGuid(
      currentBranchConfigs,
      GC.INVOICE_CARRIER_APPROVE_REASON,
    );
    return { rejectStatusReason, approveStatusReason };
  },
);

const makeSelectInvoiceStatusOptions = () => createSelector(
  store,
  ({ invoiceStatusOptions }) => invoiceStatusOptions,
);

export {
  makeSelectConfigs,
  makeSelectItemList,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectReportStatus,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
  makeSelectInvoiceStatusOptions,
  makeSelectReconciliationConfigs,
};
